// src/pages/AlertZone.jsx
// src/features/spotting/pages/AlertZone.jsx
import React, { useState } from 'react';
import { Search, AlertTriangle } from 'lucide-react';
import { PinterestGrid } from '../../../components/shared/PinterestGrid';  

export const AlertZone = ({ sightings, loading, showToast, setReportId, setZoomImg }) => {
  // ... reszta kodu BEZ ZMIAN) => {
  const [searchQuery, setSearchQuery] = useState("");

  const alertSightings = sightings.filter(s => s.isAlert && !s.hidden);

  const filtered = alertSightings
    .filter(s => {
      const search = searchQuery.toLowerCase();
      return (s.plate?.toLowerCase().includes(search)) || 
             (s.brand?.toLowerCase().includes(search)) ||
             (s.vin?.toLowerCase().includes(search));
    })
    .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

  if (loading) return <div className="p-12 text-center text-gray-500">Ładowanie...</div>;

  return (
    <div className="max-w-7xl mx-auto p-4 pb-32 lg:pb-4">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-3">
          <div className="bg-red-600 p-3 rounded-xl animate-pulse">
            <AlertTriangle className="text-white" size={28}/>
          </div>
          <div>
            <h1 className="text-3xl font-black text-red-600">
              Alert Zone
            </h1>
            <p className="text-sm text-gray-600">Pojazdy skradzione, poszukiwane i wymagające szczególnej uwagi</p>
          </div>
        </div>
      </div>

      <div className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl py-4 mb-6">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
          <input 
            type="text" 
            placeholder="Szukaj tablicy, VIN lub marki..." 
            className="w-full pl-10 pr-4 py-3 bg-red-50 text-sm font-medium text-slate-900 rounded-xl border border-red-200 outline-none focus:ring-2 focus:ring-red-500 transition-all placeholder:text-gray-400" 
            value={searchQuery} 
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="text-center py-20">
          <AlertTriangle className="mx-auto mb-4 text-gray-300" size={48}/>
          <p className="text-gray-500 font-semibold">Brak pojazdów w Alert Zone</p>
          <p className="text-sm text-gray-400 mt-2">To dobra wiadomość!</p>
        </div>
      ) : (
        <PinterestGrid 
          sightings={filtered} 
          showToast={showToast} 
          setReportId={setReportId}
          setZoomImg={setZoomImg}
        />
      )}
    </div>
  );
};